import { render, staticRenderFns } from "./bird.vue?vue&type=template&id=5c8be938&"
import script from "./bird.vue?vue&type=script&lang=js&"
export * from "./bird.vue?vue&type=script&lang=js&"
import style0 from "./bird.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports